export default {
	SHIFTPLANNER: 0,
	JUCIER_DETAILS: 1,
};
